// extracted by mini-css-extract-plugin
export default {"avatar_list":"AvatarList_avatar_list__VGAj0"};